module.exports = __webpack_public_path__ + "static/media/CARTA_AUTORIZACION(PM).9bd93683.jpg";